import { RenderContent } from '@/components/blocks/RenderContent';
import { useContentRecommendation } from '@/data/Content/ContentRecommendation';
import { Box, Typography } from '@mui/material';

const EMS_NAME = 'DPV2DisclaimerCustomProduct';

export const DisclaimerCustomProduct = () => {
    const { data, loading } = useContentRecommendation(EMS_NAME);
    if (loading) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '22px',
                paddingBottom: { xs: '38px', sm: '0px' },
                paddingTop: { xs: '0px', sm: '10px' },
                paddingX: { xs: '15px', sm: '0px' },
            }}
        >
            <Typography
                sx={{
                    fontSize: '12px',
                    fontWeight: 'normal',
                    color: '#2C2C2C',
                    display: 'inline',
                }}
            >
                {data?.map((content) => (
                    <RenderContent key={`${content.id}${content.contentId}`} content={content} />
                ))}
            </Typography>
        </Box>
    );
};
